export const THEME_COLORS = {
    green: '#468B5B',
    textMain: '#79553A',
};
